import { generateMutations } from '../builder'

export default {
  ...generateMutations('login', 'user'),
  ...generateMutations('logout', 'user'),
  ...generateMutations('me', 'user'),
}
